enum Paths {
  MAIN_PAGE = "/",
}

export default Paths;
